// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(HttpBackend) // Carga las traducciones usando HTTP (desde public/locales)
    .use(LanguageDetector) // Detecta el idioma del navegador
    .use(initReactI18next) // Conecta con React
    .init({
        fallbackLng: 'es', // Idioma por defecto
        debug: false, // Cambia a true para ver logs de depuración
        ns: ['common'], // Namespaces que utilizarás
        defaultNS: 'common',
        supportedLngs: ['es', 'en'], // Lista de idiomas soportados
        load: 'languageOnly', // Importante: Ignorar la región
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json', // Ruta para cargar las traducciones
        },
        react: {
            useSuspense: false, // Evita advertencias de Suspense
        },
        detection: {
            // Opcional: Configura cómo se detecta el idioma
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
            caches: ['cookie'],
        },
    });

export default i18n;
